export const DEFAULT_CONTACTS_URL = 'https://www.pentabank.com/kontakty';
export const DEPOSIT_INFO_URL =
  'https://www.pentabank.cz/kontakty/jak-vlozit-prostredky';
